<template>
    <div class="lm-order-fields">
        <div class="lm-order-fields__title">
            Контакты получателя
        </div>

        <combo-input
            class="lm-order-fields__group"
            v-for="item in userFieldsList"
            :key="item.name"
            v-model="user[item.name]"
            @blur="$v.user[item.name].$touch()"
            :label="item.label"
            :error-visible="$v.user[item.name].$error"
            :options="getContact(item.contactsField)" />

        <div class="lm-order-fields__group lm-order-fields__group_lg">
            <div
                class="lds-checkbox"
                :class="{'lds-checkbox_error': $v.user.agreement.$error}">
                <input
                    type="checkbox"
                    id="agreement"
                    name="agreement"
                    v-model="user.agreement">
                <label
                    class="lds-checkbox__label"
                    for="agreement">
                    Я согласен с&nbsp;<router-link to="/rules">условиями работы&nbsp;</router-link>
                    с сетью Leads
                </label>
            </div>
            <div
                v-if="$v.user.agreement.$error"
                class="lds-checkbox__error">
                Поле обязательно для заполнения
            </div>
        </div>
    </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import ComboInput from '../../common/ComboInput.vue';

export default {
    name: 'OrderRecipientFields',
    components: {ComboInput},
    props: {
        initialUser: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            user: {
                fullName: '',
                phone: '',
                email: '',
                agreement: false,
            },
            userFieldsList: [
                {
                    name: 'fullName',
                    label: 'ФИО получателя',
                    contactsField: 'fullNames',
                },
                {
                    name: 'phone',
                    label: 'Телефон',
                    contactsField: 'phones',
                },
                {
                    name: 'email',
                    label: 'Email или TG',
                    contactsField: 'emails',
                },
            ],
            testValue: '',
        };
    },
    validations: {
        user: {
            fullName: { required },
            phone: { required },
            email: { required },
            agreement: {
                required,
                sameAs: sameAs(() => true),
            },
        },
    },
    computed: {
        ...mapGetters('market', [
            'filteredContacts',
        ]),
    },
    watch: {
        user: {
            handler(newUser) {
                this.$emit('update:user', { ...newUser });
            },
            deep: true,
        },
    },
    created() {
        if (this.initialUser) {
            this.user = { ...this.initialUser };
        }
    },
    methods: {
        getContact(field) {
            if (this.filteredContacts && this.filteredContacts.userData && this.filteredContacts.userData[field]) {
                return this.filteredContacts.userData[field].filter(item => item);
            }
        },
    },
};
</script>
